import Vue from "vue";
import VueRouter from "vue-router";
import store from '@/store/index.js';

import Login from "@/components/LoginPage";
import Dashboard from "@/components/HomeIndex";
import SchoolInfo from "@/components/SchoolInfo";
import UpdatePassword from "@/components/UpdatePassword";

import CampusList from "@/components/campus/CampusList";
import CampusCreate from "@/components/campus/CampusCreate";
import CampusDetail from "@/components/campus/CampusDetail";
import CampusEdit from "@/components/campus/CampusEdit";

import AdminList from "@/components/admin/AdminList";
import AdminCreate from "@/components/admin/AdminCreate";
import AdminDetail from "@/components/admin/AdminDetail";
import AdminEdit from "@/components/admin/AdminEdit";

import GradeFeeList from "@/components/grade_fee/GradeFeeList";
import GradeFeeCreate from "@/components/grade_fee/GradeFeeCreate";
import GradeFeeEdit from "@/components/grade_fee/GradeFeeEdit";
import GradeFeeDetail from "@/components/grade_fee/GradeFeeDetail";

import HolidayList from "@/components/holiday/HolidayList";
import HolidayCreate from "@/components/holiday/HolidayCreate";
import HolidayEdit from "@/components/holiday/HolidayEdit";
import HolidayDetail from "@/components/holiday/HolidayDetail";

import GradingSettingList from "@/components/grading_setting/GradingSettingList";
import GradingSettingCreate from "@/components/grading_setting/GradingSettingCreate";
import GradingSettingEdit from "@/components/grading_setting/GradingSettingEdit";
import GradingSettingDetail from "@/components/grading_setting/GradingSettingDetail";
import GradingRuleCreate from "@/components/grading_setting/GradingRuleCreate";
import GradingRuleEdit from "@/components/grading_setting/GradingRuleEdit";

import PaymentMethodList from "@/components/payment_method/PaymentMethodList";
import PaymentMethodCreate from "@/components/payment_method/PaymentMethodCreate";
import PaymentMethodEdit from "@/components/payment_method/PaymentMethodEdit";
import PaymentMethodDetail from "@/components/payment_method/PaymentMethodDetail";

import TeacherTypeList from "@/components/teacher_type/TeacherTypeList";
import TeacherTypeCreate from "@/components/teacher_type/TeacherTypeCreate";
import TeacherTypeEdit from "@/components/teacher_type/TeacherTypeEdit";
import TeacherTypeDetail from "@/components/teacher_type/TeacherTypeDetail";

import SubjectList from "@/components/subject/SubjectList";
import SubjectCreate from "@/components/subject/SubjectCreate";
import SubjectEdit from "@/components/subject/SubjectEdit";
import SubjectDetail from "@/components/subject/SubjectDetail";

import ClassList from "@/components/class/ClassList";
import ClassCreate from "@/components/class/ClassCreate";
import ClassEdit from "@/components/class/ClassEdit";
import ClassDetail from "@/components/class/ClassDetail";

import PeriodList from "@/components/academic_period/PeriodList";
import PeriodCreate from "@/components/academic_period/PeriodCreate";
import PeriodEdit from "@/components/academic_period/PeriodEdit";

import GradeList from "@/components/grade/GradeList";
import GradeCreate from "@/components/grade/GradeCreate";
import GradeEdit from "@/components/grade/GradeEdit";

import GradingList from "@/components/grading/GradingList";
import GradingCreate from "@/components/grading/GradingCreate";
import GradingImport from "@/components/grading/GradingImport";
import GradingDetail from "@/components/grading/GradingDetail";
import GradingEdit from "@/components/grading/GradingEdit";

import ExamList from "@/components/exam/ExamList";
import ExamCreate from "@/components/exam/ExamCreate";
import ExamDetail from "@/components/exam/ExamDetail";
import ExamEdit from "@/components/exam/ExamEdit";

import CampusGradeList from "@/components/campus_grade/CampusGradeList";
import CampusGradeCreate from "@/components/campus_grade/CampusGradeCreate";
import CampusGradeEdit from "@/components/campus_grade/CampusGradeEdit";

import TimetableTemplateList from "@/components/timetable_template/TimetableTemplateList";
import TimetableTemplateCreate from "@/components/timetable_template/TimetableTemplateCreate";
import TimetableTemplateDetail from "@/components/timetable_template/TimetableTemplateDetail";
import TimetableTemplateEdit from "@/components/timetable_template/TimetableTemplateEdit";

import TimetableList from "@/components/timetable/TimetableList";
import TimetableCreate from "@/components/timetable/TimetableCreate";
import TimetableDetail from "@/components/timetable/TimetableDetail";
import TimetableEdit from "@/components/timetable/TimetableEdit";

import TeacherList from "@/components/teacher/TeacherList";
import TeacherCreate from "@/components/teacher/TeacherCreate";
import TeacherProfile from "@/components/teacher/TeacherProfile";
import TeacherEdit from "@/components/teacher/TeacherEdit";

import AttendanceTeacherList from "@/components/attendance_teacher/AttendanceTeacherList";
import AttendanceTeacherCreate from "@/components/attendance_teacher/AttendanceTeacherCreate";
import AttendanceTeacherDetail from "@/components/attendance_teacher/AttendanceTeacherDetail";
import AttendanceTeacherEdit from "@/components/attendance_teacher/AttendanceTeacherEdit";

import AttendanceStudentList from "@/components/attendance_student/AttendanceStudentList";
import AttendanceStudentCreate from "@/components/attendance_student/AttendanceStudentCreate";
import AttendanceStudentDetail from "@/components/attendance_student/AttendanceStudentDetail";
import AttendanceStudentEdit from "@/components/attendance_student/AttendanceStudentEdit";

import SalaryList from "@/components/salary/SalaryList";
import SalaryCreate from "@/components/salary/SalaryCreate";
import SalaryEdit from "@/components/salary/SalaryEdit";
import SalaryDetail from "@/components/salary/SalaryDetail";

import LeaveList from "@/components/leave/LeaveList";
import LeaveCreate from "@/components/leave/LeaveCreate";
import LeaveEdit from  "@/components/leave/LeaveEdit";
import LeaveDetail from  "@/components/leave/LeaveDetail";

import CourseList from '@/components/course/CourseList'
import CourseCreate from '@/components/course/CourseCreate'
import CourseEdit from '@/components/course/CourseEdit'
import CourseDetail from '@/components/course/CourseDetail'

import NoticeList from '@/components/notice/NoticeList'
import NoticeCreate from '@/components/notice/NoticeCreate'
import NoticeDetail from '@/components/notice/NoticeDetail'
import NoticeEdit from '@/components/notice/NoticeEdit'

import SubjectTeacherList from '@/components/subject_teacher/SubjectTeacherList'
import SubjectTeacherCreate from '@/components/subject_teacher/SubjectTeacherCreate'
import SubjectTeacherEdit from '@/components/subject_teacher/SubjectTeacherEdit'
import SubjectTeacherDetail from '@/components/subject_teacher/SubjectTeacherDetail'

import TransactionList from '@/components/transaction/TransactionList'
import TransactionCreate from '@/components/transaction/TransactionCreate'
import TransactionEdit from '@/components/transaction/TransactionEdit'
import TransactionDetail from '@/components/transaction/TransactionDetail'

import StudentList from "@/components/student/StudentList";
import StudentCreate from "@/components/student/StudentCreate";
import StudentProfile from "@/components/student/StudentProfile";
import StudentEdit from "@/components/student/StudentEdit";
import StudentPass from "@/components/student/StudentPass";
import StudentFail from "@/components/student/StudentFail";
import StudentRestore from "@/components/student/StudentRestore";

import ParentList from '@/components/parent/ParentList'
import ParentCreate from '@/components/parent/ParentCreate'
import ParentAndStudentCreate from '@/components/parent/ParentAndStudentCreate'
import ParentEdit from '@/components/parent/ParentEdit'
import ParentDetail from '@/components/parent/ParentDetail'

import TransactionReport from "@/components/report/TransactionReport.vue";
import IncomeExpenseReport from '@/components/report/IncomeExpenseReport.vue';
import PassPercentage from '@/components/report/PassPercentage.vue';

import ItemList from "@/components/item/ItemList";
import ItemCreate from "@/components/item/ItemCreate";
import ItemDetail from "@/components/item/ItemDetail";
import ItemEdit from "@/components/item/ItemEdit";

import PaymentList from "@/components/payment/PaymentList";
import PaymentCreate from "@/components/payment/PaymentCreate";
import PaymentDetail from "@/components/payment/PaymentDetail";
import PaymentEdit from "@/components/payment/PaymentEdit";
import PaymentCheckout from "@/components/payment/PaymentCheckout";

import FerryCreate from "@/components/ferry/FerryCreate";
import FerryList from "@/components/ferry/FerryList";
import FerryEdit from "@/components/ferry/FerryEdit";
import FerryDetail from "@/components/ferry/FerryDetail";

import DriverList from "@/components/driver/DriverList";
import DriverCreate from "@/components/driver/DriverCreate";
import DriverEdit from "@/components/driver/DriverEdit";
import DriverDetail from "@/components/driver/DriverDetail";

import RouteList from "@/components/route/RouteList";
import RouteCreate from "@/components/route/RouteCreate";
import RouteEdit from "@/components/route/RouteEdit";
import RouteDetail from "@/components/route/RouteDetail";

import FerryPickupList from "@/components/ferry_pickup/FerryPickupList";
import FerryPickupDetail from "@/components/ferry_pickup/FerryPickupDetail";
import FerryPickupEdit from "@/components/ferry_pickup/FerryPickupEdit";

import DailyFerryList from "@/components/daily_ferry/DailyFerryList";
import DailyFerryCreate from "@/components/daily_ferry/DailyFerryCreate";
import DailyFerryEdit from "@/components/daily_ferry/DailyFerryEdit";
import DailyFerryDetail from "@/components/daily_ferry/DailyFerryDetail";
import DailyFerryCopyForm from "@/components/daily_ferry/DailyFerryCopyForm";

import AboutUs from "@/components/AboutUs";
import PrivacyPolicy from "@/components/PrivacyPolicy";

import SettingPage from "@/components/setting/SettingPage";
import SettingEdit from "@/components/setting/SettingEdit";

import ChatRequestList from "@/components/chat/RequestList";
import ChatMessageHistory from "@/components/chat/ChatHistory";

import CategoryItems from "@/components/library/categoryItems.vue";
import AppFormList from "@/components/application_form/appFormList";
import AppFormCreate from "@/components/application_form/appFormCreate";
import AppFormItems from "@/components/application_form/appFormItems";
import AppFormDetail from "@/components/application_form/appFormDetail";
import AppFormEdit from "@/components/application_form/appFormEdit";
import AppFormEditItems from "@/components/application_form/appFormEditItems";
import InitialScreenPreview from "@/components/application_form/initialScreenPreview";

import ApplicantList from "@/components/applicant/ApplicantList";
import ApplicantDetail from "@/components/applicant/ApplicantDetail";

import BookList from "@/components/book_library/BookList";
import BookCreate from "@/components/book_library/BookCreate";
import BookDetail from "@/components/book_library/BookDetail";
import BookEdit from "@/components/book_library/BookEdit";

import LibraryMemberList from "@/components/library_member/LibraryMemberList";
import LibraryMemberCreate from "@/components/library_member/LibraryMemberCreate";
import LibraryMemberDetail from "@/components/library_member/LibraryMemberDetail";
import LibraryMemberEdit from "@/components/library_member/LibraryMemberEdit";

import CheckoutCreate from "@/components/checkout/CheckoutCreate";
import CheckoutList from "@/components/checkout/CheckoutList";
import CheckoutDetail from "@/components/checkout/CheckoutDetail";
import CheckoutEdit from "@/components/checkout/CheckoutEdit";

import DamageLossesCreate from "@/components/damage-losses/DamageLossesCreate";
import DamageLossesList from "@/components/damage-losses/DamageLossesList";
import DamageLossesDetail from "@/components/damage-losses/DamageLossesDetail";
import DamageLossesEdit from "@/components/damage-losses/DamageLossesEdit";

import AttendanceRateList from "@/components/attendance_rate/AttendanceRateList";

import AssignmentList from "@/components/assignment/assignmentList";
import AssignmentCreate from "@/components/assignment/assignmentCreate";
import AssignmentEdit from "@/components/assignment/assignmentEdit";
import AssignmentDetail from "@/components/assignment/assignmentDetail";

import MonthlyAttendance from "@/components/student/monthly_attendance/MonthlyAttendanceList";

import TeacherLeaveList from "@/components/teacher_leave/LeaveList";
import TeacherLeaveCreate from "@/components/teacher_leave/LeaveCreate";
import TeacherLeaveEdit from  "@/components/teacher_leave/LeaveEdit";
import TeacherLeaveDetail from  "@/components/teacher_leave/LeaveDetail";

import HostelList from "@/components/hostel/HostelList";
import HostelCreate from "@/components/hostel/HostelCreate";
import HostelEdit from  "@/components/hostel/HostelEdit";
import HostelDetail from  "@/components/hostel/HostelDetail";
import CampusGradeImport from "@/components/campus_grade/CampusGradeImport";
import SubjectImport from "@/components/subject/SubjectImport";

import GradeFeeImport from "@/components/grade_fee/GradeFeeImport";
import SubjectTeacherImport from "@/components/subject_teacher/SubjectTeacherImport";

import TransactionCategoryCreate from "@/components/transaction_category/TransactionCategoryCreate";
import TransactionCategoryEdit from "@/components/transaction_category/TransactionCategoryEdit";
import TransactionCategoryDetail from "@/components/transaction_category/TransactionCategoryDetail";
import TransactionCategoryList from "@/components/transaction_category/TransactionCategoryList";

import DailyCashflow from "@/components/cashflow/DailyCashflow";
import MonthlyCashflow from "@/components/cashflow/MonthlyCashflow";
import YearlyCashflow from "@/components/cashflow/YearlyCashflow";
import FinancialSummaryReport from "@/components/cashflow/FinancialSummaryReport";
import PaymentMethodBalanceList from "@/components/payment_method_balance/PaymentMethodBalanceList";

import CONFIG from "@/assets/js/config.js";

Vue.use(VueRouter);

//Prevent double navigation and suppress errors
['push', 'replace'].forEach(method => {
  const original = VueRouter.prototype[method];
  VueRouter.prototype[method] = function(location, onResolve, onReject) {
    if (this.currentRoute.fullPath === this.resolve(location).route.fullPath) {
      return Promise.resolve(this.currentRoute);
    }
    const result = original.call(this, location, onResolve, onReject);
    if (result && typeof result.catch === 'function') {
      return result.catch(err => {
        if (
          ['NavigationDuplicated', 'NavigationCancelled'].includes(err.name) ||
          (typeof err.message === 'string' && err.message.includes('Navigation cancelled'))
        ) {
          return;
        }
        throw err;
      });
    }
    return result;
  };
});

const routes = [
  {
    path: "/login",
    name: "login",
    component: Login,
  },

  {
    path: "/campus/list",
    name: "campusList",
    component: CampusList,
    meta: { restricted: ["staff", "accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/campus/create",
    name: "campusCreate",
    component: CampusCreate,
    meta: { restricted: ["staff", "accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/campus/detail/:id",
    name: "campusDetail",
    component: CampusDetail
  },
  {
    path: "/campus/edit/:id",
    name: "campusEdit",
    component: CampusEdit,
    meta: { restricted: ["staff", "accountant", "libraryAdmin", "classMonitor"] }
  },

  {
    path: "/admin/list",
    name: "adminList",
    component: AdminList,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/admin/create",
    name: "adminCreate",
    component: AdminCreate,
    meta: { restricted: ["staff", "accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/admin/detail/:id",
    name: "adminDetail",
    component: AdminDetail,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/admin/edit/:id",
    name: "adminEdit",
    component: AdminEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/gradeFee/list",
    name: "gradeFeeList",
    component: GradeFeeList,
    meta: { restricted: ["libraryAdmin", "classMonitor"] }
  },
  {
    path: "/gradeFee/create",
    name: "gradeFeeCreate",
    component: GradeFeeCreate,
    meta: { restricted: ["libraryAdmin", "classMonitor"] }
  },
  {
    path: "/gradeFee/edit/:id",
    name: "gradeFeeEdit",
    component: GradeFeeEdit,
    meta: { restricted: ["libraryAdmin", "classMonitor"] }
  },
  {
    path: "/gradeFee/detail/:id",
    name: "gradeFeeDetail",
    component: GradeFeeDetail,
    meta: { restricted: ["libraryAdmin", "classMonitor"] }
  },
  {
    path: "/holiday/list",
    name: "holidayList",
    component: HolidayList,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/holiday/create",
    name: "holidayCreate",
    component: HolidayCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/holiday/edit/:id",
    name: "holidayEdit",
    component: HolidayEdit,
    mmeta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  
  {
    path: "/holiday/detail/:id",
    name: "holidayDetail",
    component: HolidayDetail,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/gradingSetting/list",
    name: "gradingSettingList",
    component: GradingSettingList,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/gradingSetting/create",
    name: "gradingSettingCreate",
    component: GradingSettingCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/gradingSetting/edit/:id",
    name: "gradingSettingEdit",
    component: GradingSettingEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/gradingSetting/detail/:id",
    name: "gradingSettingDetail",
    component: GradingSettingDetail,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/gradingSetting/:gradingSettingId/rule/create",
    name: "gradingRuleCreate",
    component: GradingRuleCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/gradingSetting/:gradingSettingId/rule/edit/:id",
    name: "gradingRuleEdit",
    component: GradingRuleEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/paymentMethod/list",
    name: "paymentMethodList",
    component: PaymentMethodList,
    meta: { restricted: ["libraryAdmin", "classMonitor"] }
  },
  {
    path: "/paymentMethod/create",
    name: "paymentMethodCreate",
    component: PaymentMethodCreate,
    meta: { restricted: ["libraryAdmin", "classMonitor"] }
  },
  {
    path: "/paymentMethod/edit/:id",
    name: "paymentMethodEdit",
    component: PaymentMethodEdit,
    meta: { restricted: ["libraryAdmin", "classMonitor"] }
  },
  {
    path: "/paymentMethod/detail/:id",
    name: "paymentMethodDetail",
    component: PaymentMethodDetail,
    meta: { restricted: ["libraryAdmin", "classMonitor"] }
  },
  {
    path: "/teacherType/list",
    name: "teacherTypeList",
    component: TeacherTypeList,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/teacherType/create",
    name: "teacherTypeCreate",
    component: TeacherTypeCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/teacherType/edit/:id",
    name: "teacherTypeEdit",
    component: TeacherTypeEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/teacherType/detail/:id",
    name: "teacherTypeDetail",
    component: TeacherTypeDetail,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/subject/list",
    name: "subjectList",
    component: SubjectList,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/subject/create",
    name: "subjectCreate",
    component: SubjectCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/subject/edit/:campusGradeId",
    name: "subjectEdit",
    component: SubjectEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/subject/detail/:campusGradeId",
    name: "subjectDetail",
    component: SubjectDetail,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/class/list",
    name: "classList",
    component: ClassList,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/class/create",
    name: "classCreate",
    component: ClassCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/class/edit/:id",
    name: "classEdit",
    component: ClassEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/class/detail/:id",
    name: "classDetail",
    component: ClassDetail,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/",
    name: "dashboard",
    component: Dashboard,
    meta: { restricted: ["libraryAdmin", "classMonitor"]}
  },
  {
    path: "/school/:id",
    name: "school",
    component: SchoolInfo,
  },
  {
    path: "/updatePassword",
    name: "updatePassword",
    component: UpdatePassword,
  },
  {
    path: "/period/list",
    name: "periodList",
    component: PeriodList,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/period/create",
    name: "periodCreate",
    component: PeriodCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/period/edit/:id",
    name: "periodEdit",
    component: PeriodEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/grade/list",
    name: "gradeList",
    component: GradeList,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/grade/create",
    name: "gradeCreate",
    component: GradeCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/grade/edit/:id",
    name: "gradeEdit",
    component: GradeEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/grading/list",
    name: "gradingList",
    component: GradingList,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/grading/create",
    name: "gradingCreate",
    component: GradingCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/grading/detail/:student_id/:exam_id",
    name: "gradingDetail",
    component: GradingDetail,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/grading/import",
    name: "gradingImport",
    component: GradingImport,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/grading/edit/:student_id/:exam_id",
    name: "gradingEdit",
    component: GradingEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/exam/list",
    name: "examList",
    component: ExamList,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/exam/create",
    name: "examCreate",
    component: ExamCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/exam/detail/:exam_id",
    name: "examDetail",
    component: ExamDetail,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/exam/edit/:exam_id",
    name: "examEdit",
    component: ExamEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/campusGrade/list",
    name: "campusGradeList",
    component: CampusGradeList,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/campusGrade/create",
    name: "campusGradeCreate",
    component: CampusGradeCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/campusGrade/edit/:id",
    name: "campusGradeEdit",
    component: CampusGradeEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/timetableTemplate/list",
    name: "timetableTemplateList",
    component: TimetableTemplateList,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/timetableTemplate/create",
    name: "timetableTemplateCreate",
    component: TimetableTemplateCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/timetableTemplate/detail/:id",
    name: "timetableTemplateDetail",
    component: TimetableTemplateDetail,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/timetableTemplate/edit/:id",
    name: "timetableTemplateEdit",
    component: TimetableTemplateEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/timetable/list",
    name: "timetableList",
    component: TimetableList,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/timetable/create",
    name: "timetableCreate",
    component: TimetableCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/timetable/detail/:id",
    name: "timetableDetail",
    component: TimetableDetail,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/timetable/edit/:id",
    name: "timetableEdit",
    component: TimetableEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/teacher/list",
    name: "teacherList",
    component: TeacherList,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/teacher/create",
    name: "teacherCreate",
    component: TeacherCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/teacher/profile/:id",
    name: "teacherProfile",
    component: TeacherProfile,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/teacher/edit/:id",
    name: "teacherEdit",
    component: TeacherEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/salary/list",
    name: "salaryList",
    component: SalaryList,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/salary/create",
    name: "salaryCreate",
    component: SalaryCreate,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/salary/edit/:id",
    name: "salaryEdit",
    component: SalaryEdit,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/salary/detail/:id",
    name: "salaryDetail",
    component: SalaryDetail,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/attendanceTeacher/list",
    name: "attendanceTeacherList",
    component: AttendanceTeacherList,
    meta: { restricted: ["libraryAdmin", "classMonitor"] }
  },
  {
    path: "/attendanceTeacher/create",
    name: "attendanceTeacherCreate",
    component: AttendanceTeacherCreate,
    meta: { restricted: ["libraryAdmin", "classMonitor"] }
  },
  {
    path: "/attendanceTeacher/detail/:teacher_id/:date",
    name: "attendanceTeacherDetail",
    component: AttendanceTeacherDetail,
    meta: { restricted: ["libraryAdmin", "classMonitor"] }
  },
  {
    path: "/attendanceTeacher/edit/:teacher_id/:date",
    name: "attendanceTeacherEdit",
    component: AttendanceTeacherEdit,
    meta: { restricted: ["libraryAdmin", "classMonitor"] }
  },
  {
    path: "/attendanceStudent/list",
    name: "attendanceStudentList",
    component: AttendanceStudentList,
    meta: { restricted: ["accountant", "libraryAdmin"] }
  },
  {
    path: "/attendanceStudent/create",
    name: "attendanceStudentCreate",
    component: AttendanceStudentCreate,
    meta: { restricted: ["accountant", "libraryAdmin"] }
  },
  {
    path: "/attendanceStudent/detail/:id",
    name: "attendanceStudentDetail",
    component: AttendanceStudentDetail,
    meta: { restricted: ["accountant", "libraryAdmin"] }
  },
  {
    path: "/attendanceStudent/edit/:id",
    name: "attendanceStudentEdit",
    component: AttendanceStudentEdit,
    meta: { restricted: ["accountant", "libraryAdmin"] }
  },
  {
    path: "/leave/list",
    name: "leaveList",
    component:LeaveList,
    meta: { restricted: ["accountant", "libraryAdmin"] }
  },
  {
    path: "/leave/create",
    name: "leaveCreate",
    component: LeaveCreate,
    meta: { restricted: ["accountant", "libraryAdmin"] }
  },
  {
    path: "/leave/edit/:id",
    name: "leaveEdit",
    component:LeaveEdit,
    meta: { restricted: ["accountant", "libraryAdmin"] }
  },
  {
    path: "/leave/detail/:id",
    name: "leaveDetail",
    component:LeaveDetail,
    meta: { restricted: ["accountant", "libraryAdmin"] }
  },

  {
    path: "/course/list",
    name: "courseList",
    component:CourseList,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/course/create",
    name: "courseCreate",
    component:CourseCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/course/edit/:id",
    name: "courseEdit",
    component:CourseEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/course/detail/:id",
    name: "courseDetail",
    component:CourseDetail,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },

  {
    path: "/notice/list",
    name: "noticeList",
    component:NoticeList,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/notice/create",
    name: "noticeCreate",
    component:NoticeCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/notice/detail/:id",
    name: "noticeDetail",
    component:NoticeDetail,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/notice/edit/:id",
    name: "noticeEdit",
    component:NoticeEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/subjectTeacher/list",
    name: "subjectTeacherList",
    component: SubjectTeacherList,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/subjectTeacher/create",
    name: "subjectTeacherCreate",
    component: SubjectTeacherCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/subjectTeacher/edit/:id",
    name: "subjectTeacherEdit",
    component: SubjectTeacherEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/subjectTeacher/detail/:id",
    name: "subjectTeacherDetail",
    component: SubjectTeacherDetail,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/transaction/list",
    name: "transactionList",
    component: TransactionList,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/transaction/create",
    name: "transactionCreate",
    component: TransactionCreate,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/transaction/detail/:id",
    name: "transactionDetail",
    component: TransactionDetail,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/transaction/edit/:id",
    name: "transactionEdit",
    component: TransactionEdit,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/student/list",
    name: "studentList",
    component: StudentList,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/student/create/:parentId",
    name: "studentCreate",
    component: StudentCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/student/profile/:leavedStatus/:id",
    name: "studentProfile",
    component: StudentProfile,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/student/edit/:id",
    name: "studentEdit",
    component: StudentEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/student/pass/:id",
    name: "studentPass",
    component: StudentPass,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/student/fail/:id",
    name: "studentFail",
    component: StudentFail,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/student/restore/:id",
    name: "studentRestore",
    component: StudentRestore,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/parent/list",
    name: "parentList",
    component: ParentList,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/parent/create",
    name: "parentCreate",
    component: ParentCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/parent-student/create",
    name: "parentAndStudentCreate",
    component: ParentAndStudentCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/parent/edit/:id",
    name: "parentEdit",
    component: ParentEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/parent/detail/:id",
    name: "parentDetail",
    component: ParentDetail,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/item/list",
    name: "itemList",
    component: ItemList,
    meta: { restricted: ["libraryAdmin", "classMonitor"] }
  },
  {
    path: "/item/create",
    name: "itemCreate",
    component: ItemCreate,
    meta: { restricted: ["libraryAdmin", "classMonitor"] }
  },

  {
    path: "/item/detail/:id",
    name: "itemDetail",
    component: ItemDetail,
    meta: { restricted: ["libraryAdmin", "classMonitor"] }
  },

  {
    path: "/item/edit/:id",
    name: "itemEdit",
    component: ItemEdit,
    meta: { restricted: ["libraryAdmin", "classMonitor"] }
  },

  {
    path: "/payment/list",
    name: "paymentList",
    component: PaymentList,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor"] }
  },

  {
    path: "/payment/create",
    name: "paymentCreate",
    component: PaymentCreate,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor"] }
  },

  {
    path: "/payment/detail/:invoiceId",
    name: "paymentDetail",
    component: PaymentDetail,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor"] }
  },

  {
    path: "/payment/edit/:invoiceId",
    name: "paymentEdit",
    component: PaymentEdit,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor"] }
  },

  {
    path: "/payment/checkout",
    name: "paymentCheckout",
    component: PaymentCheckout,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor"] }
  },

  {
    path: "/driver/list",
    name: "driverList",
    component: DriverList,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },

  {
    path: "/driver/create",
    name: "driverCreate",
    component: DriverCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },

  {
    path: "/driver/edit/:id",
    name: "driverEdit",
    component: DriverEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },

  {
    path: "/driver/detail/:id",
    name: "driverDetail",
    component: DriverDetail,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  
  {
    path: "/ferry/create",
    name: "ferryCreate",
    component: FerryCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  }, 

  {
    path: "/ferry/list",
    name: "ferryList",
    component: FerryList,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },

  {
    path: "/ferry/edit/:id",
    name: "ferryEdit",
    component: FerryEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },

  {
    path: "/ferry/detail/:id",
    name: "ferryDetail",
    component: FerryDetail,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  
  {
    path: "/route/list",
    name: "routeList",
    component: RouteList,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },

  {
    path: "/route/create",
    name: "routeCreate",
    component: RouteCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },

  {
    path: "/route/edit/:id",
    name: "routeEdit",
    component: RouteEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },

  {
    path: "/route/detail/:id",
    name: "routeDetail",
    component: RouteDetail,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },

  {
    path: "/ferryPickup/list",
    name: "ferryPickupList",
    component: FerryPickupList,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },

  {
    path: "/ferryPickup/detail/:status/:id",
    name: "ferryPickupDetail",
    component: FerryPickupDetail,
    props: true,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },

  {
    path: "/ferryPickup/edit/:status/:id",
    name: "ferryPickupEdit",
    component: FerryPickupEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },

  {
    path: "/dailyFerry/list",
    name: "dailyFerryList",
    component: DailyFerryList,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },

  {
    path: "/dailyFerry/create",
    name: "dailyFerryCreate",
    component: DailyFerryCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },

  {
    path: "/dailyFerry/edit/:id",
    name: "dailyFerryEdit",
    component: DailyFerryEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },

  {
    path: "/dailyFerry/detail/:id",
    name: "dailyFerryDetail",
    component: DailyFerryDetail,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },

  {
    path: "/dailyFerry/duplicate/:id",
    name: "dailyFerryCopyForm",
    component: DailyFerryCopyForm,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },

  {
    path: "/aboutUs",
    name: "aboutUs",
    component: AboutUs,
  },

  {
    path: "/privacyPolicy",
    name: "privacyPolicy",
    component: PrivacyPolicy,
    meta: { public: true },
  },

  {
    path: "/setting",
    name: "settingPage",
    component: SettingPage,
    meta: { restricted: ["staff", "accountant", "libraryAdmin", "classMonitor"] }
  },

  {
    path: "/setting/edit",
    name: "settingEdit",
    component: SettingEdit,
    meta: { restricted: ["staff", "accountant", "libraryAdmin", "classMonitor"] }
  },

  {
    path: "/chat/request/list",
    name: "chatRequestList",
    component: ChatRequestList,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },

  {
    path: "/chat/message/history",
    name: "ChatMessageHistory",
    component: ChatMessageHistory,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },

  {
    path: "/library/category",
    name: "categoryItems",
    component: CategoryItems,
    meta: { restricted: ["accountant", "classMonitor"] }
  },
  
  {
    path: "/applicationForm/list",
    name: "appFormList",
    component: AppFormList,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },

  {
    path: "/applicationForm/create",
    name: "appFormCreate",
    component: AppFormCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },

  {
    path: "/applicationForm/items",
    name: "appFormItems",
    component: AppFormItems,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },

  {
    path: "/applicationForm/detail/:id",
    name: "appFormDetail",
    component: AppFormDetail,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },

  {
    path: "/applicationForm/edit/:id",
    name: "appFormEdit",
    component: AppFormEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },

  {
    path: "/applicationForm/edit/:id/items",
    name: "appFormEditItems",
    component: AppFormEditItems,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },

  {
    path: "/applicationForm/preview",
    name: "initialScreenPreview",
    component: InitialScreenPreview,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  
  {
    path: "/applicant/list",
    name: "applicantList",
    component: ApplicantList,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  
  {
    path: "/applicant/detail/:id",
    name: "applicantDetail",
    component: ApplicantDetail,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },

  {
    path: "/book_library/list",
    name: "bookList",
    component: BookList,
    meta: { restricted: ["accountant", "classMonitor"] }
  },
  {
    path: "/book_library/create",
    name: "bookCreate",
    component: BookCreate,
    meta: { restricted: ["accountant", "classMonitor"] }
  },
  {
    path: "/book_library/detail/:id",
    name: "bookDetail",
    component: BookDetail,
    meta: { restricted: ["accountant", "classMonitor"] }
  },
  {
    path: "/book_library/edit/:id",
    name: "bookEdit",
    component: BookEdit,
    meta: { restricted: ["accountant", "classMonitor"] }
  },
  {
    path: "/libraryMember/list",
    name: "libraryMemberList",
    component: LibraryMemberList,
    meta: { restricted: ["accountant", "classMonitor"] }
  },
  {
    path: "/libraryMember/create",
    name: "libraryMemberCreate",
    component: LibraryMemberCreate,
    meta: { restricted: ["accountant", "classMonitor"] }
  },
  {
    path: "/libraryMember/detail/:id",
    name: "libraryMemberDetail",
    component: LibraryMemberDetail,
    meta: { restricted: ["accountant", "classMonitor"] }
  },
  {
    path: "/libraryMember/edit/:id",
    name: "libraryMemberEdit",
    component: LibraryMemberEdit,
    meta: { restricted: ["accountant", "classMonitor"] }
  },
  {
    path: "/checkout/list",
    name: "checkoutList",
    component: CheckoutList,
    meta: { restricted: ["accountant", "classMonitor"] }
  },
  {
    path: "/checkout/create",
    name: "checkoutCreate",
    component: CheckoutCreate,
    meta: { restricted: ["accountant", "classMonitor"] }
  },
  {
    path: "/checkout/detail/:id",
    name: "checkoutDetail",
    component: CheckoutDetail,
    meta: { restricted: ["accountant", "classMonitor"] }
  },
  {
    path: "/checkout/edit/:id",
    name: "checkoutEdit",
    component: CheckoutEdit,
    meta: { restricted: ["accountant", "classMonitor"] }
  },

  {
    path: "/damagelosses/list",
    name: "damageLossesList",
    component: DamageLossesList,
    meta: { restricted: ["accountant", "classMonitor"] }
  },
  {
    path: "/damagelosses/create",
    name: "damageLossesCreate",
    component: DamageLossesCreate,
    meta: { restricted: ["accountant", "classMonitor"] }
  },
  {
    path: "/damagelosses/detail/:id",
    name: "damageLossesDetail",
    component: DamageLossesDetail,
    meta: { restricted: ["accountant", "classMonitor"] }
  },
  {
    path: "/damagelosses/edit/:id",
    name: "damageLossesEdit",
    component: DamageLossesEdit,
    meta: { restricted: ["accountant", "classMonitor"] }
  },
  {
    path: "/attendance-rate/list",
    name: "attendanceRateList",
    component: AttendanceRateList,
    meta: { restricted: ["accountant", "libraryAdmin"] }
  },
  {
    path: "/report/transaction",
    name: "transactionReport",
    component: TransactionReport,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor"] },
  },
  {
    path: "/report/income-expense",
    name: "incomeExpenseReport",
    component: IncomeExpenseReport,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor"] },
  },
  {
    path: "/report/pass-percentage",
    name: "PassPercentage",
    component: PassPercentage,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/assignment/list",
    name: "assignmentList",
    component: AssignmentList,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/assignment/create",
    name: "assignmentCreate",
    component: AssignmentCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/assignment/edit/:id",
    name: "assignmentEdit",
    component: AssignmentEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/assignment/detail/:id",
    name: "assignmentDetail",
    component: AssignmentDetail,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/monthly/attendance/list",
    name: "monthlyAttendance",
    component: MonthlyAttendance,
    meta: { restricted: ["accountant", "libraryAdmin"] }
  },
  {
    path: "/teacher/leave/list",
    name: "teacherLeaveList",
    component: TeacherLeaveList,
    meta: { restricted: ["classMonitor", "libraryAdmin"] }
  },
  {
    path: "/teacher/leave/create",
    name: "teacherLeaveCreate",
    component: TeacherLeaveCreate,
    meta: { restricted: ["classMonitor", "libraryAdmin"] }
  },
  {
    path: "/teacher/leave/edit/:id",
    name: "teacherLeaveEdit",
    component: TeacherLeaveEdit,
    meta: { restricted: ["classMonitor", "libraryAdmin"] }
  },
  {
    path: "/teacher/leave/detail/:id",
    name: "teacherLeaveDetail",
    component: TeacherLeaveDetail,
    meta: { restricted: ["classMonitor", "libraryAdmin"] }
  },
  {
    path: "/hostel/list",
    name: "hostelList",
    component: HostelList,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/hostel/create",
    name: "hostelCreate",
    component: HostelCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/hostel/edit/:id",
    name: "hostelEdit",
    component: HostelEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/hostel/detail/:id",
    name: "hostelDetail",
    component: HostelDetail,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/campusGrade/import",
    name: "campusGradeImport",
    component: CampusGradeImport,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] },
  },
  {
    path: "/subject/import",
    name: "subjectImport",
    component: SubjectImport,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] }
  },
  {
    path: "/gradeFee/import",
    name: "gradeFeeImport",
    component: GradeFeeImport,
    meta: { restricted: ["libraryAdmin", "classMonitor"] },
  },
  {
    path: "/subjectTeacher/import",
    name: "subjectTeacherImport",
    component: SubjectTeacherImport,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor"] },
  },
  {
    path: "/transactionCategory/list",
    name: "transactionCategoryList",
    component: TransactionCategoryList,
    meta: { restricted: ["libraryAdmin", "classMonitor"] },
  },
  {
    path: "/transactionCategory/create",
    name: "transactionCategoryCreate",
    component: TransactionCategoryCreate,
    meta: { restricted: ["libraryAdmin", "classMonitor"] },
  },
  {
    path: "/transactionCategory/detail/:id",
    name: "transactionCategoryDetail",
    component: TransactionCategoryDetail,
    meta: { restricted: ["libraryAdmin", "classMonitor"] },
  },
  {
    path: "/transactionCategory/edit/:id",
    name: "transactionCategoryEdit",
    component: TransactionCategoryEdit,
    meta: { restricted: ["libraryAdmin", "classMonitor"] },
  },
  {
    path: "/report/daily-cashflow",
    name: "dailyCashflow",
    component: DailyCashflow,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor"] },
  },
  {
    path: "/report/monthly-cashflow",
    name: "monthlyCashflow",
    component: MonthlyCashflow,
    meta: { restricted:["staff", "libraryAdmin", "classMonitor"] },
  },
  {
    path: "/report/yearly-cash-flow",
    name: "yearlyCashflow",
    component: YearlyCashflow,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor"] },
  },
  {
    path: "/report/financial-summary",
    name: "financialSummaryReport",
    component: FinancialSummaryReport,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor"] },
  },
  {
    path: "/payment-method-balance/list",
    name: "paymentMethodBalanceList",
    component: PaymentMethodBalanceList,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor"] },
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
});

router.beforeEach((to, from, next) => {
  let authUser = store.state.user.admin_no;
  if (to.name !== 'login' && !authUser)
    next({ name: 'login' })
  else next()
})

router.beforeEach((to, from, next) => {
  let authUser = store.state.user.role;
  let adminUser = store.state.user.admin_no;
  let restricted = to.meta.restricted;

  if (!restricted) return next();

  const restrictedRoles = Array.isArray(restricted) ? restricted : [restricted];

  const ROLE = CONFIG.ROLE.ID;
  let currentRole = null;

  if (authUser === ROLE.STAFF) currentRole = "staff";
  else if (authUser === ROLE.ACCOUNTANT) currentRole = "accountant";
  else if (authUser === ROLE.LIBRARY_ADMIN) currentRole = "libraryAdmin";
  else if (authUser === ROLE.CLASS_MONITOR) currentRole = "classMonitor";
  else if (adminUser != "0001") currentRole = "admin";
  else if (adminUser == "0001") currentRole = "superAdmin";

  if (restrictedRoles.includes(currentRole)) {
    // Blocked role → redirect
    if (currentRole === "libraryAdmin") {
      next({ name: "categoryItems" });
    } else if (currentRole === "classMonitor") {
      next({ name: "attendanceStudentList" });
    } else if (currentRole === "superAdmin") {
      next({ name: "adminList" });
    } else {
      next({ name: "dashboard" });
    }
  } else {
    next();
  }
});

router.beforeEach((to,from,next)=>{
  if(to.name === "teacherTypeEdit" && to.params.id === '1'){
    next({name: "teacherTypeList"})
  } else {
    next();
  }
});

router.beforeEach((to,from,next)=>{
  if(to.name === "chatRequestList" && !store.state.setting.teacherChatApproval){
    next({ name: "dashboard"});
  } else {
    next();
  }
});

export default router;
